import { createSlice } from '@reduxjs/toolkit';
import extraReducers from 'src/redux/issues/extra-reducers';
import reducers from './reducers';
import { issueSliceInitialState } from './types';

const issueSlice = createSlice({
  name: 'issues',
  initialState: issueSliceInitialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});
export const {
  editIssueData,
  editIssueDataFromSR,
  updateIssuesSource,
  updateIssuesSourceFromSR,
  updateIssueDataOnAssign,
  deleteIssueFromSource,
  updateIssueMedia,
  updateIssueRecommendedToolsMaterials,
  updateIssueOnSRWorkOrderUpdate,
  optimisticAddRecommendedItem,
  rollbackOptimisticRecommendedItem,
  optimisticRemoveRecommendedItem,
  rollbackRemovedRecommendedItem,
  optimisticUpdateRecommendedItem,
  rollbackUpdatedRecommendedItem,
} = issueSlice.actions;

export default issueSlice.reducer;
